import { compose } from 'recompose';
import ModulesItem from './modulesItem';

const enhance = compose();
export default enhance(ModulesItem);
